import {
    ApolloClient,
    gql,
    MutationOptions,
    TypedDocumentNode,
} from '@apollo/client'
import { cartFragment } from '@emico-hooks/cart-fragment'

import {
    RemoveItemFromCartMutation,
    RemoveItemFromCartMutationVariables,
} from './removeItemFromCart.generated'

const mutation = gql`
    mutation RemoveItemFromCart(
        $cartId: String!
        $cartItemUid: ID!
        $restore: Boolean!
    ) {
        removeItemFromCart(
            input: {
                cart_id: $cartId
                cart_item_uid: $cartItemUid
                restore: $restore
            }
        ) {
            cart {
                ...CartFragment
            }
        }
    }

    ${cartFragment}
` as TypedDocumentNode<
    RemoveItemFromCartMutation,
    RemoveItemFromCartMutationVariables
>

export function removeItemFromCart(
    client: ApolloClient<unknown>,
    cartId: string,
    cartItemUid: string,
    withRestore: boolean,
    options?: Omit<
        MutationOptions<
            RemoveItemFromCartMutation,
            RemoveItemFromCartMutationVariables
        >,
        'mutation' | 'variables'
    >,
) {
    return client.mutate({
        mutation,
        variables: {
            cartId,
            cartItemUid,
            restore: withRestore,
        },
        ...options,
    })
}
